export const SelectStyle = {
  roundedStyle: {
    default: {
      borderRadius: '0.25rem',
      height: '47px',
      border: '1px solid #434175',
      padding: '.375rem .75rem',
      fontSize: '1rem'
    },
    focus: {
      border: '1px solid #F5821F'
    },
    label: {
      fontSize: 15,
      color: "#000",
      fontWeight: 700,
      marginBottom: 0,
    },
    optionStyle: {
      fontSize: 16
    },
  },
  lineStyle: {
    default: {
      border: '0',
      borderBottom: '1px solid #d3d3d3',
      fontSize: '.75rem',
      color: '#212529',
      borderRadius: '0',
      padding: '0 3px',
      height: '35px',
    },
    focus: {
      borderBottom: '1px solid #F5821F',
    },
    label: {
      fontSize: '.75rem',
      color: '#555',
      paddingLeft: 3,
      fontWeight: 700,
      marginBottom: 0,
    },
    optionStyle: {
      fontSize: 16
    },
  },
  defaultStyle: {
    default: {
      borderRadius: ".25rem",
      border: "1px solid #434175",
      height: 47,
    },
    label: {
      fontSize: 15,
      color: "#000",
      fontWeight: 700,
    },
    optionStyle: {
      fontSize: 14
    },
    focus: {
      border: "1px solid #434175",
    }
  }
}